/**
 * Export Status Object
 */
export default class ExportStatus {
    /**
     * @param {object} data data
     * @param {number=} data.exportStatusId exportStatusId
     * @param {string=} data.name name
     */
    constructor({
        exportStatusId,
        name,
    } = {}) {
        this.exportStatusId = exportStatusId
        this.name = name
    }
}
